// import {useEffect, useState} from "react";
import { useActiveButton } from "../../../services/context/ActiveButtonContext"
import { useDispatch, useSelector } from "react-redux"
import { getCard, getTable } from "../../../utils/api"
import styles from "./tables.module.css"
import { NavLink } from "react-router-dom"
import CanMightBeInteresting from "../../can-might-be-interesting/can-might-be-interesting"
import {
  setSubForFetch,
  setTableName,
} from "../../../services/reducers/tables-slice"
import { Tab, Tabs } from "../../tabs/tabs"
import { useEffect } from "react"
import TablesSubPanel from "./tablesSubPanel"
import SubButtonLinks from "./subButtonLink"


function Tables() {
  const val = useActiveButton()
  const dispatch = useDispatch()

  const object = useSelector((store) => store.cards.object)

  const objectWithSub = object.filter(
    (item) =>
      item.page_category[0].name === "Аналитика" && item.subscription !== null
  )
  const objectWithoutSub = object.filter(
    (item) =>
      item.page_category[0].name === "Аналитика" && item.subscription === null
  )
  let finalObject

  if (objectWithSub.length > 0) {
    finalObject = [
      ...objectWithSub.slice(0, 1),
      ...objectWithoutSub.slice(0, 2),
    ]
  } else {
    finalObject = objectWithoutSub.slice(0, 3)
  }

  const handleClick = (subName) => {
    dispatch(setSubForFetch(subName))
    // dispatch(setTableName(name))
  }

  useEffect(() => {
    val.getAvailableTablesContext()
    val.CanMightBeInteresting()
  }, [])

  // console.log(val.availableTables);

  const isDisabledSub = (sub) => {
    const boolean = val.availableTables.filter((el) => {
      return el.name === sub
    }).length
    return !!boolean
  }
  // console.log(val.availableTables)
  return (
    <>
      <div className={styles.headerContainer} />
      <section className={styles.section}>
        <div className={styles.linkWrapper}>
          <NavLink to={"/"} className={styles.link}>
            <div className={styles.arrow}></div>
            Главная
          </NavLink>
        </div>

        <div className={styles.container}>
          <div className={styles.leftSide}>
            <h2 className={styles.title}>Портфели</h2>

            <div>
            {val.availableTables.length === 0 ? (
              <TablesSubPanel />
            ) : (
            <div className={styles.scrollWrapper}>
              <div className={styles.tabsWrapper}>
                {val.availableTables.map((el, i) => {
                  return (
                    <div
                      key={i}
                      className={
                        val.tabNumber === i
                          ? styles.tabWrapActive
                          : styles.tabWrap
                      }
                      onClick={() => {
                        val.setTabNumber(i)
                      }}
                    >
                      <div className={val.tabNumber === i
                        ? styles.tabTitleActive
                        : styles.tabTitle
                    }>{el.name}</div>
                    </div>
                  )
                })}
              </div>
            </div>)}
              {val.availableTables.length !== 0 &&
                val.availableTables[val.tabNumber].tables.map((elTables, ind) => {
                  return (
                    <div className={styles.tablesWrapper} key={ind}>
                      <div className={styles.tables}>
                        <div className={styles.box}>
                          {elTables.main_title !== "null" && (
                            <h4 className={styles.countryName}>
                              {elTables.main_title}
                            </h4>
                          )}
                          {elTables.table.map((elTable, i) => (
                            <div className={styles.subsectionWrapper} key={i}>
                              {(elTable.title !== "null") && <div className={styles.subsectionTitle}>
                                {elTable.title}
                              </div>}
                              {elTable.links.map((link, index) => (
                                <NavLink
                                  to={`${link.url}`}
                                  className={styles.linkComponent}
                                  key={index}
                                >
                                  {link.name}
                                </NavLink>
                              ))}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )
                })}
                {val.availableTables.length !== 0 && <SubButtonLinks />}
              
            </div>
          </div>
          <div className={styles.monitor}>
            <CanMightBeInteresting posts={finalObject} />
          </div>
        </div>

        <div className={styles.phone}>
          <CanMightBeInteresting posts={finalObject} />
        </div>
      </section>
    </>
  )
}

export default Tables
